<!--品牌下拉框-->
<template>
  <div>
    <el-select v-model="brandId" @change="brandSelectChang" @clear="brandClear" :clearable="true">
      <el-option v-for="item in brandOptions"
                 :key="item.value"
                 :label="item.label"
                 :value="item.value"
      ></el-option>
    </el-select>
  </div>
</template>

<script>

import api from "@/api/projectApi";

export default {
  name: 'brandSelect',
  props: {
    brandId: {
      require: true
    },
    brandName: {}
  },

  computed: {
  },

  mounted() {
    this.loadBrandOption()
  },

  data() {
    return {
      brandOptions: []
    }
  },

  watch: {

  },


  methods: {
    brandClear() {
      this.brandName = null
      this.$emit('update:brandId', null)
      this.$emit('update:brandName', null)
    },

    brandSelectChang() {
      this.$emit('update:brandId', this.brandId)
      this.brandOptions.forEach(item => {
        if (this.brandId === item.value) {
          this.brandName = item.label
        }
      })
      this.$emit('update:brandName', this.brandName)
    },

    // 加载品牌
    loadBrandOption() {
      this.$http.post(api.snCompanyBrand.getBrandListUrl, {usable: 1}).then(res => {
        this.brandOptions = []
        res.data.data.forEach(item => {
          this.brandOptions.push({
            label: item.brandName,
            value: item.id
          })
        })
      })
    },
  },
};
</script>

<style scoped lang="scss">

</style>
